<template>
  <div>
    <a-modal
      title="Review this request approval setting?"
      :visible="visible && !visibleAppliedRules && !!suggestion"
      :mask-closable="false"
      :closable="!loading"
      data-testid="applied-rules-review-suggestion"
      @cancel="dismiss"
    >
      <p data-testid="applied-rules-review-body">{{ body }}</p>
      <template slot="footer">
        <a-button :disabled="loading" data-testid="applied-rules-review-not-now" @click="dismiss">Not Now</a-button>
        <a-button :loading="loading" data-testid="applied-rules-review-open" @click="reviewAppliedRules">
          Review Applied Rules
        </a-button>
      </template>
    </a-modal>
    <applied-rules
      v-if="visibleAppliedRules"
      :visible="visibleAppliedRules"
      :review-associate.sync="reviewAssociate"
      :suggested-auth-type="suggestion.type"
      @update:visible="finishReview"
    />
  </div>
</template>

<script>
import { Button, Modal, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import ProfileViewAppliedRules from './profile-view-applied-rules.vue'

const { mapActions: profileActions } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-button': Button,
    'a-modal': Modal,
    'applied-rules': ProfileViewAppliedRules
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    suggestions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      index: 0,
      loading: false,
      visibleAppliedRules: false,
      reviewAssociate: null
    }
  },
  computed: {
    suggestion() {
      return this.suggestions[this.index]
    },
    body() {
      if (!this.suggestion) return ''
      const { associate, name, approvedCount } = this.suggestion
      const associateName = [associate.first_name, associate.last_name].filter(Boolean).join(' ')
      const intro =
        approvedCount === 4
          ? `This is the 4th approved ${name} for ${associateName} in the current disciplinary period.`
          : `There are now ${approvedCount} approved ${name} for ${associateName} in the current disciplinary period.`
      return `${intro} You may want to review whether this request approval type should stay available for this associate.`
    }
  },
  methods: {
    ...profileActions(['getAssociateById']),

    dismiss() {
      if (this.loading) return
      this.index += 1
      if (!this.suggestion) this.$emit('update:visible', false)
    },

    async reviewAppliedRules() {
      if (this.loading || !this.suggestion) return
      this.loading = true
      try {
        const { associate } = await this.getAssociateById({ associate_id: this.suggestion.associate.id })
        if (associate?.id !== this.suggestion.associate.id || !Array.isArray(associate.available_auth_types)) {
          throw new Error('Applied Rules could not be loaded for this associate. Please try again.')
        }
        this.reviewAssociate = associate
        this.visibleAppliedRules = true
      } catch (error) {
        notification.error({
          message: 'Could not open Applied Rules',
          description: error.message || error
        })
      } finally {
        this.loading = false
      }
    },

    finishReview(visible) {
      if (visible) return
      this.visibleAppliedRules = false
      this.reviewAssociate = null
      this.dismiss()
    }
  }
}
</script>
